import { useEffect, useState } from "react";

export default function Countdown({ deadline, size = "lg" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const end = deadline ? new Date(deadline).getTime() : null;
  const diff = end ? Math.max(0, end - now) : 0;
  const h = String(Math.floor(diff / 3600000)).padStart(2, "0");
  const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, "0");
  const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, "0");
  const expired = end && diff === 0;

  const cls = size === "lg" ? "text-5xl sm:text-6xl" : "text-2xl";
  return (
    <div className="flex items-center gap-2" data-testid="countdown">
      <span className="relative flex h-3 w-3">
        {!expired && <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />}
        <span className={`relative inline-flex rounded-full h-3 w-3 ${expired ? "bg-slate-400" : "bg-emerald-500"}`} />
      </span>
      <span className={`font-mono-digit font-semibold ${cls} ${expired ? "text-slate-400" : "text-emerald-500"}`}>
        {expired ? "00:00:00" : `${h}:${m}:${s}`}
      </span>
    </div>
  );
}
